export class Clock {
    seconds: number = 0;
    minutes: number = 0;
    interval = null;
    status: number = 0; 
}



// WEBPACK FOOTER //
// ./src/app/shared/clock.model.ts